import { ActorRoles } from '.'
import {
  EVENT_HUB_LINK,
  HOME_LINK,
  HOST_ADMIN_LINK,
  SMART_BOOK_INSIGHTS_LINK,
  SMART_BOOK_EVENTS_LINK,
  HOST_HOME_LINK,
  SMART_BOOK_HOME_LINK
} from '../Constants'
import { useGlobalState } from '../Store'

export const hostAdmin = `${HOST_ADMIN_LINK}/lf-leads`

const rootUrl: Record<ActorRoles, string> = {
  [ActorRoles.UNKNOWN]: HOME_LINK,
  [ActorRoles.B2C_GUEST]: HOME_LINK,
  [ActorRoles.LEAD_FEED_HOST]: HOST_HOME_LINK,
  [ActorRoles.SMART_BOOK_HOST]: SMART_BOOK_HOME_LINK,
  [ActorRoles.BIZ_MEMBER_LEGACY]: EVENT_HUB_LINK,
  [ActorRoles.BIZ_MANAGER_LEGACY]: EVENT_HUB_LINK,
  [ActorRoles.BIZ_ADMIN_LEGACY]: EVENT_HUB_LINK,
  [ActorRoles.BIZ_MANAGER]: SMART_BOOK_EVENTS_LINK,
  [ActorRoles.BIZ_MEMBER]: SMART_BOOK_EVENTS_LINK,
  [ActorRoles.BIZ_ADMIN]: SMART_BOOK_INSIGHTS_LINK,
  [ActorRoles.ACCOUNT_MANAGER]: hostAdmin,
  [ActorRoles.REGIONAL_MANAGER]: hostAdmin,
  [ActorRoles.ADMIN]: hostAdmin
}

export const useRootUrl = (): string => {
  const [{ role }] = useGlobalState('session')

  if (role === undefined) {
    return HOME_LINK
  }

  return rootUrl[role]
}
